// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === 452) return "static/css/452.22b987a6.css";
  // return url for filenames based on template
  return "" + chunkId + ".css"
}